import React from 'react';
import HomeTwoMain from './HomeTwoMain';
import HeaderTwo from '../../components/Header/HeaderTwo';
import Footer from '../../components/Footer';

const HomeTwo = () => {
  return (
    <>
      <HeaderTwo />

      <HomeTwoMain />

      <Footer />
    </>
  );
};

export default HomeTwo;
